class DropdownComponent extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.heading = this.querySelector(".dropdown-component__heading");
		this.options = this.querySelector(".dropdown-component__options");
		this.icon = this.querySelector(".dropdown-component__icon");

		this.heading.addEventListener("click", () => {
			this.toggleOptions();
		});

		this.options.addEventListener("click", (e) => {
			e.stopPropagation();
			const option = e.target.closest(".dropdown-component__option");
			if (option) {
				const selectedText =
					option.querySelector(".dropdown-component__option-text")?.textContent ?? "";
				const headingTextNode = this.heading.childNodes[0];
				if (headingTextNode.nodeType === Node.TEXT_NODE) {
					headingTextNode.nodeValue = selectedText + " ";
				}

				this.heading.style.color = "#231f20";
				this.options.classList.add("dropdown-component__options--hidden");
				this.updateIconState();
			}
		});

		window.addEventListener("click", (e) => {
			if (!this.contains(e.target)) {
				this.options.classList.add("dropdown-component__options--hidden");
				this.updateIconState();
			}
		});
	}

	toggleOptions() {
		this.options.classList.toggle("dropdown-component__options--hidden");
		this.updateIconState();
	}

	updateIconState() {
		if (!this.icon) return;
		const isOpen = !this.options.classList.contains("dropdown-component__options--hidden");
		if (isOpen) {
			this.icon.classList.add("dropdown-component__icon--open");
		} else {
			this.icon.classList.remove("dropdown-component__icon--open");
		}
	}
}

customElements.define("dropdown-component", DropdownComponent);
